import React, { useState } from "react"
import Modal from "aldoo-ra/Modal"
import Button from "aldoo-ra/Button"
import CMSData from "aldoo-ra/CMS/cms-data"

const DEFAULT_REASON_IDS = ["price", "technical", "product", "autobill", "no_need", "other"]

const ReasonDialog = ({ isOpen, onClose, onNext, texts }) => {
  const [selectedReason, setSelectedReason] = useState(null)

  const defaultReasonLabels = {
    price: texts?.reasonPrice,
    technical: texts?.reasonTechnical,
    product: texts?.reasonProduct,
    autobill: texts?.reasonAutobill,
    no_need: texts?.reasonNoNeed,
    other: texts?.reasonOther,
  }

  const { data: reasonsData = [] } = CMSData({ contentType: "UnsubscribeReasons" })

  const raw = reasonsData[0]?.reasons
  let reasons = DEFAULT_REASON_IDS.map((id) => ({ id, label: defaultReasonLabels[id] }))
  if (raw && typeof raw === "object" && !Array.isArray(raw)) {
    reasons = Object.entries(raw).map(([key, value]) => ({ id: key, label: value }))
  } else if (Array.isArray(raw) && raw.length > 0) {
    reasons = raw.map((item) => ({ id: item.key ?? item.id, label: item.value ?? item.label }))
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      variant="centered"
      className="md:max-w-md"
      closeOnEscape={true}
      title={texts?.reasonTitle}
    >
      <div className="flex flex-col gap-5">
        <p className="text-sm text-text_secondary mt-0 mb-2">
          {texts?.reasonSubtitle}
        </p>

        <div className="flex flex-col gap-2">
          {reasons.map((reason) => (
            <label
              key={reason.id}
              className={`flex items-center gap-3 px-4 py-3 rounded-xl border cursor-pointer transition-colors ${
                selectedReason === reason.id
                  ? "border-primary bg-primary/5"
                  : "border-bordered hover:bg-canvas"
              }`}
            >
              <input
                type="radio"
                name="cancel-reason"
                checked={selectedReason === reason.id}
                onChange={() => setSelectedReason(reason.id)}
                className="accent-primary"
              />
              <span className="text-sm text-text">{reason.label}</span>
            </label>
          ))}
        </div>

        {selectedReason && (
          <div className="flex justify-end">
            <Button variant="primary" onClick={() => onNext(selectedReason)}>
              {texts?.next}
            </Button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default ReasonDialog
